import { Button } from 'reactstrap';

function Form(props) {

    function onSubmitClick() {
        props.updateFormComplete(true);
    }

    return (
        <div>
            <h4>
                Hi, welcome to Quizzer! This is a web app that uses the <a href='https://opentdb.com/api_config.php'>Open Trivia Database API</a> to test your trivia skills!
                 I will soon update the app to allow the ability to choose between categories and dificulty levels. Try your best to get the longest correct streak possible! Have fun!
            </h4>
            <form>

            </form>
            <Button color='primary' onClick={onSubmitClick}>START</Button>
        </div>
    )
}

export default Form;